import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import NavbarUI from "../components/NavBarUI";
import { getUser } from "../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function Navbar() {
  const [empresa, setEmpresa] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(location.pathname);
  const user = Cookies.get('user') ? JSON.parse(Cookies.get('user')) : null;

  useEffect(() => {
    setSelected(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        const user = getUser();
        const response = await fetch(`${URL}/api/empresas/${user.empresa_id}`);
        if (response.ok) {
          const data = await response.json();
          setEmpresa(data);
        } else {
          console.error("Error al obtener la empresa");
        }
      } catch (error) {
        console.error("Error de red al obtener la empresa", error);
      }
    };

    fetchEmpresa();
  }, []);

  const handleChange = (_, newValue) => {
    setSelected(newValue);
    navigate(newValue); // Navegar a la nueva ruta
  };

  const tabs = [
    { value: "/", icon: "home", label: "Principal" },

    { value: "/ventas", icon: "sell", label: "Ventas" },
    
    user?.rol === "Jefe" && { value: "/actividad", icon: "chart", label: "Actividad" },
    
    { 
      value: "/inventario", 
      icon: "warehouse", 
      label: empresa?.rubro === "Servicios" ? "Mis Servicios" : "Inventario",
      hasStockSubItem: empresa?.stock
    },

    empresa?.stock && { value: "/inventario/stock", icon: "shelves", label: "Stock" },
    
    user?.rol === "Jefe" && { value: "/datos", icon: "analytics", label: "Datos" },
  ].filter(Boolean);

  return (
    <NavbarUI
      selected={tabs.some(t => t.value === selected) ? selected : false}
      handleChange={handleChange}
      tabs={tabs}
    />
  );
}